import Collage from './Collage';

export default Collage;
